var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetsuite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.177 29.28c3.99 4.726 7.958 9.854 12.015 14.624h19.35v10.834H26.177V29.28z",
    fill: "#14487E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9C7D4",
    d: "M40.466 19.539v-8.627h14.78v31.053h-9.898V19.539zm-21.111 1.939V43.77h4.86v8.739H9.435V21.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14487E",
    d: "M7.161 8.816h31.366v25.503l-12.194-14.78H7.161z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjR2NjRIMHoiLz48cGF0aCBkPSJNMjYuMTc3IDI5LjI4YzMuOTkgNC43MjYgNy45NTggOS44NTQgMTIuMDE1IDE0LjYyNGgxOS4zNXYxMC44MzRIMjYuMTc3VjI5LjI4eiIgZmlsbD0iIzE0NDg3RSIvPjxwYXRoIGZpbGw9IiNCOUM3RDQiIGQ9Ik00MC40NjYgMTkuNTM5di04LjYyN2gxNC43OHYzMS4wNTNoLTkuODk4VjE5LjUzOXptLTIxLjExMSAxLjkzOVY0My43N2g0Ljg2djguNzM5SDkuNDM1VjIxLjQ3OHoiLz48cGF0aCBmaWxsPSIjMTQ0ODdFIiBkPSJNNy4xNjEgOC44MTZoMzEuMzY2djI1LjUwM2wtMTIuMTk0LTE0Ljc4SDcuMTYxeiIvPjwvZz48L3N2Zz4=";
export { SvgNetsuite as ReactComponent };